import * as React from "react";
import firebase from "../../firebase/firebase";
import GlobalStyles from "@mui/material/GlobalStyles";
import CssBaseline from "@mui/material/CssBaseline/CssBaseline";
import Container from "@mui/material/Container/Container";
import Typography from "@mui/material/Typography/Typography";
import Tags from "./tags";
import TopBar from "../../components/TopBarV2";
import Box from "@mui/material/Box/Box";
import Button from "@mui/material/Button/Button";
import Stack from "@mui/material/Stack/Stack";
import { useIntl } from "react-intl";
import TextField from "@mui/material/TextField/TextField";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import { CheckCircle } from "@mui/icons-material";
import CircularProgress, {
	circularProgressClasses,
	CircularProgressProps,
} from "@mui/material/CircularProgress";
import { styled } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { AuthUserContext } from "../../providers/AuthProvider";
import Dialog from "@mui/material/Dialog/Dialog";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
import IconButton from "@mui/material/IconButton/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogContentText from "@mui/material/DialogContentText/DialogContentText";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import PostNotification from "../../helpers/post-notification";
import ScrollToTop from "../../utils/scrollTop";
export default function AdditionalInformation(props: CircularProgressProps) {
	const [open, setOpen] = React.useState(false);
	const [error, setError] = React.useState();
	const storageRef = firebase.storage().ref();
	const { user, profile } = React.useContext(AuthUserContext);
	const navigator = useNavigate();
	let value = "Utility bills";
	const { messages } = useIntl();
	const [type, setType] = React.useState();
	const [files, setFiles] = React.useState();
	const Input = styled("input")({
		display: "none",
	});
	const setFile = (e) => {
		const list = files ? [...files] : [];

		list.push({ file: e.target.files[0], progress: 0, type });
		setFiles(list);
	};
	const uploadFile = () => {
		files.forEach((file, i) => {
			if (file.progress === 0) {
				const path = `additional-docs/${user?.uid}/${file.file.name}`;
				const uploadTask = storageRef.child(path).put(file.file);
				uploadTask.on(
					"state_changed",
					(snapshot) => {
						// Observe state change events such as progress, pause, and resume
						// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
						const progress =
							(snapshot.bytesTransferred / snapshot.totalBytes) *
							100;
						const newState = files;
						newState[i].progress = progress;
						setFiles([...newState]);
						console.log("Upload is " + progress + "% done");
						switch (snapshot.state) {
							case firebase.storage.TaskState.PAUSED: // or 'paused'
								console.log("Upload is paused");
								break;
							case firebase.storage.TaskState.RUNNING: // or 'running'
								console.log("Upload is running");
								break;
						}
					},
					(error) => {},
					() => {
						const newState = files;
						newState[i].progress = 100;
						newState[i].url = path;
						setFiles([...newState]);
						// Handle successful uploads on complete
						// For instance, get the download URL: https://firebasestorage.googleapis.com/...
					}
				);
			} else {
				return file;
			}
		});
	};
	const postDocs = async () => {
		if (files.length > 0 && files.every((d) => d.progress === 100)) {
			const documnetsRef = firebase
				.firestore()
				.collection("verification-documents");
			const mapFiles = files.map((d) => {
				return { url: d.url, type, verified: false };
			});
			try {
				const post = await documnetsRef.add({
					uid: user.uid,
					documents: mapFiles,
					createdAt: firebase.firestore.FieldValue.serverTimestamp(),
					name: profile?.name,
					userType: profile?.userType,
				});
				/*
				 *     TODO: creator user navigation
				 * */
				const postId = await PostNotification({
					title: "New user application",
					text: "A new user uploaded documentation for verification. Click here to review.",
					uid: null,
					createdBy: "self",
					showing: ["super", "admin"],
					link: "/admin/user-pending",
				});
				console.log(`Notify Admin ${postId}`);

				if (profile?.userType === "investor")
					navigator("/investor/projects-tags");
				else if (profile?.userType === "artist")
					navigator("/artists/dashboard");
				else navigator("/creator/dashboard");
			} catch (e) {
				/*
				 * TODO: show the error message
				 * */
			}
		} else {
			/*
			 * TODO: show the error message
			 * */
			console.log("Doc uploading failed");
		}
	};
	return (
		<>
		<ScrollToTop/>
			<GlobalStyles
				styles={{ ul: { margin: 0, padding: 0, listStyle: "none" } }}
			/>
			{/* Hero unit */}
			{/*<TopBar/>*/}
			<Container maxWidth="md" component="main" sx={{ mt: 8, mb: 10 }}>
				<Box sx={{}}>
					<Typography
						variant="h4"
						align="left"
						color="text.primary"
						component="p">
						Upload your documentation
					</Typography>

					<Typography
						variant="body1"
						align="left"
						color="text.primary"
						component="p"
						sx={{ margin: "30px 0px" }}>
						For this step you will need the{" "}
						<font color="#204488">following documents:</font>
						<ul
							style={{
								listStyle: "inside",
							}}>
							<li>Drivers license/Identification documents *</li>
							<li>Utility bills</li>
						</ul>
					</Typography>

					<Typography
						variant="body1"
						align="left"
						color="text.primary"
						component="p"
						sx={{ margin: "30px 0px" }}>
						Please note that we only require utility bills in case
						your address is different from your Drivers license.
					</Typography>
				</Box>
			</Container>

			<Container maxWidth="md" component="main" sx={{ mt: 8 }}>
				<Stack
					direction="row"
					justifyContent="center"
					alignItems="flex-start"
					spacing={2}>
					<TextField
						fullWidth
						variant={"outlined"}
						error={error ? true : false}
						helperText={error ? error : ""}
						select
						onChange={(e) => {
							setType(e.target.value);

							if (
								e.target.value !==
								"Drivers License/Identification documents"
							) {
								if (files && files.length > 0) {
									const find = files.find(
										(f) =>
											f.type ===
											"Drivers License/Identification documents"
									);
									if (!find) {
										setError(
											"This is compulsory. Please select Drivers License/Identification documents"
										);

										/*
										 * show msg
										 * */
									} else {
										setError();
									}
								} else {
									setError(
										"This is compulsory. Please select Drivers License/Identification documents"
									);
									/*
									 * show msg
									 * */
								}

								// alert('This is compulsory. Please select Drivers License/Identification documents ')
							} else {
								setError();
							}
						}}
						label={"Select document type"}
						sx={{ textAlign: "left" }}>
						<MenuItem
							value={"Drivers License/Identification documents"}>
							Drivers license/Identification documents
						</MenuItem>
						<MenuItem value={"Utility bills"}>
							Utility bills
						</MenuItem>
					</TextField>
					<label htmlFor="document-upload">
						<Input
							accept="**/*"
							id="document-upload"
							multiple={false}
							type="file"
							onChange={setFile}
						/>
						<Button
							component="span"
							variant={"outlined"}
							color={"primary"}
							startIcon={<AddIcon />}
							sx={{
								minWidth: 180,
								paddingY: "12.5px",
								borderRadius: 0,
							}}
							size={"large"}>
							Choose file
						</Button>
					</label>

					<Button
						variant={"contained"}
						color={"primary"}
						sx={{
							minWidth: 150,
							paddingY: "15px",
							borderRadius: 0,
						}}
						onClick={uploadFile}>
						Upload
					</Button>
				</Stack>
			</Container>

			<Container maxWidth="md" component="main" sx={{ mt: 5 }}>
				{files &&
					files.length > 0 &&
					files.map((d, i) => (
						<Stack
							key={i}
							direction="row"
							justifyContent="flex-start"
							alignItems="center"
							spacing={2}
							sx={{
								borderBottom: "1px solid #ccc",
								paddingY: 2,
							}}>
							<Stack
								direction="row"
								justifyContent="flex-start"
								alignItems="center"
								spacing={2}
								sx={{ flex: 1 }}>
								{d.progress > 0 && d.progress < 100 ? (
									<CircularProgress
										variant="indeterminate"
										disableShrink
										sx={{
											color: (theme) =>
												theme.palette.mode === "light"
													? "#b9b9bc"
													: "#909093",
											animationDuration: "550ms",
											left: 0,
											[`& .${circularProgressClasses.circle}`]:
												{
													strokeLinecap: "round",
												},
										}}
										size={30}
										thickness={4}
										{...props}
									/>
								) : (
									<>
									{d.progress === 100 && <CheckCircle color={"primary"} style={{ height: 20, width: 20}}/>}
									{d.progress === 0 && 
										<img
										src="/assets/icons/file-upload.png"
										style={{ height: 20, width: 20 }}
										alt=""
										/>
									}
									</>
									
								)}

								<Typography
									color={
										d.progress > 0 && d.progress < 100
											? ""
											: "secondary"
									}>
									{d.file.name}
								</Typography>
								{console.log(d.progress === 100)}
								{d.progress === 100 && (
									<Dialog
										open={open}
										onClose={() => setOpen(false)}
										aria-labelledby="alert-dialog-title"
										aria-describedby="alert-dialog-description"
										fullWidth
										maxWidth="sm">
										<DialogTitle id="alert-dialog-title">
											<Stack
												direction={"row"}
												spacing={2}>
												<Typography
													variant={"h6"}
													sx={{
														flex: 1,
														textAlign: "center",
													}}
													color={"primary"}>
													Thank you!{" "}
												</Typography>
												<IconButton
													color={"primary"}
													onClick={() => {
														setOpen(false);
														// navigator.goBack();
														postDocs();
													}}>
													<CloseIcon />
												</IconButton>
											</Stack>
										</DialogTitle>
										<DialogContent sx={{ py: 5 }}>
											<DialogContentText id="alert-dialog-description">
												<Typography
													variant={"body2"}
													sx={{
														textAlign: "center",
													}}>
													We will notify you once your
													documents have been verified
													by the admin. Please note
													that this may take up to two
													weeks.
												</Typography>
											</DialogContentText>
										</DialogContent>
									</Dialog>
								)}
							</Stack>
							<Box
								sx={{
									paddingX: 2,
									borderRight: "1px solid #ccc",
								}}>
								<Box
									sx={{
										p: 1,
										background: "#F1EFEF",
										fontSize: "small",
										color: "#848484",
									}}>
									{(d.file.size / 1024 / 1024).toFixed(0) == 0
										? (d.file.size / 1024).toFixed(0) +
										  " KB"
										: (d.file.size / 1024 / 1024).toFixed(
												0
										  ) + " MB"}
								</Box>
							</Box>
							<Fab
								sx={{
									backgroundColor: "#F1EFEF",
									color: "#848484",
									boxShadow: "none",
								}}
								size={"small"}
								aria-label="delete"
								onClick={() => {
									setFiles([
										...files.slice(0, i),
										...files.slice(i + 1, files.length),
									]);
								}}>
								<ClearIcon />
							</Fab>
						</Stack>
					))}
			</Container>

			<Container maxWidth="md" component="main" sx={{ marginY: 5 }}>
				<Stack
					direction="row"
					justifyContent="center"
					alignItems="center"
					spacing={10}>
					<Button
						variant={"outlined"}
						color={"primary"}
						sx={{
							minWidth: 150,
							paddingY: "10px",
							textTransform: "uppercase",
						}}
						onClick={() => navigator(-1)}>
						Go back
					</Button>
					<Button
						variant={"contained"}
						color={"primary"}
						sx={{
							minWidth: 150,
							paddingY: "10px",
							textTransform: "uppercase",
						}}
						onClick =   {() =>{ 
											setOpen(true);
										}
									}
						disabled={
							files &&
							files.every &&
							files.every((e) => e.progress === 100) &&
							files.find(
								(f) =>
									f.type ===
									"Drivers License/Identification documents"
							)
								? false
								: true
						}>
						Next
					</Button>
					<Button
						variant={"outlined"}
						color={"primary"}
						sx={{
							minWidth: 150,
							paddingY: "10px",
							textTransform: "uppercase",
						}}
						onClick={() => {
							if (profile?.userType === "creator")
								navigator("/creator/dashboard");
							else if (profile?.userType === "artist")
								navigator("/artists/dashboard");
							else navigator("/investor/projects-tags");
						}}>
						Skip
					</Button>
				</Stack>
			</Container>
		</>
	);
}
